import styled from 'styled-components';
import { BlockContent as _BlockContent } from '../EditInfoForm/EditInfoForm.style';

export const BlockContent = styled(_BlockContent)`
  margin: -1.6rem 2.8rem -1.4rem;
  padding: 0;
`;
